import { render, staticRenderFns } from "./BdInfo.vue?vue&type=template&id=eee7426c&scoped=true&"
import script from "./BdInfo.vue?vue&type=script&lang=js&"
export * from "./BdInfo.vue?vue&type=script&lang=js&"
import style0 from "./BdInfo.vue?vue&type=style&index=0&id=eee7426c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee7426c",
  null
  
)

export default component.exports